(function(){
  "use strict";

  angular.module('eclipseApp.core').controller('confirmChangeInternetModalCtrl', ['$scope', '$injector', '$state', '$modalInstance', 'accountDashboardManager', function ($scope, $injector, $state, $modalInstance, accountDashboardManager) {
    $scope.ok = function () {
      console.log('OKOK');
      accountDashboardManager.resetConfirmation();
      $state.go('myAccount.internet.package.change.review');
      $modalInstance.close();
    };

    $scope.cancel = function () {
      $modalInstance.dismiss('cancel');
    };

  }]);

})();
